import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Form, Button, Input, InputNumber, Radio, Row, Select, Typography, Image, Spin, Checkbox, Flex } from 'antd';
import { getMarketRates, getOffices } from '../../components/utiles/DataForCombos';
import { Navigate, useNavigate } from 'react-router-dom';
import HttpService, { history, HttpServiceHandler } from '../../support/HttpService';
import { Context } from '../../components/context';
import dayjs from 'dayjs';
import { StringRegex, NumberRegex } from '../../support/Utiles';
import ReCAPTCHA from 'react-google-recaptcha';
import { GenericErrors } from '../../components/utiles/GenericErrors';

const { Option } = Select;
const { Title, Text } = Typography;

function Step2() {
    return (
        <>
            <FormGroup />
        </>
    );

}


function FormGroup() {

    const captchaApiKey = '##CAPTCHA-KEY##';

    const location = useLocation();
    history.navigate = useNavigate();

    const recaptcha = useRef();

    const [form] = Form.useForm();
    const [accountType, setAccountType] = useState(null);

    const [isCardSelected, setCard] = useState(true);
    const [isNewReceptionAdress, setReceptionAdress] = useState(false);
    const [localityStatus, setLocalityStatus] = useState(true);
    const [zipCode, setZipCode] = useState(0);
    const [isPrevButtonPressed, setPressed] = useState(false)

    const [loading, setLoading] = useState(true);
    HttpServiceHandler.setLoading = setLoading;

    const [tipoTarjeta, setTipoTarjeta] = useState('V');
    const { states, dependencies, setDependencies, marketRates, setMarketRates, basePath } = useContext(Context);

    useEffect(() => {        
        setTimeout(() => {
            HttpService.get(basePath + '/api/dependencies')
                .then(response => {
                    setDependencies(response.data.content);
                })
                .catch(error => {
                    setDependencies(getOffices());
                })

            //rewardProgramInitialValue.current = 'Club Card';

            HttpService.get(basePath + '/api/marketRates')
                .then(response => {
                    setMarketRates(response.data.content);
                })
                .catch(error => {
                    setMarketRates(getMarketRates());
                })

            setLoading(false);
        }, 2000);
    }, [])

    const [additionalCreditApplication, setAdditionalCrediApplication] = useState('Si');
    const [additionalCreditApplicationC, setAdditionalCrediApplicationC] = useState('No');

    const [cardTypes, setCardTypes] = useState([
        { value: '1', label: 'Platinum' },
        { value: '2', label: 'Internacional' },        
        { value: '4', label: 'Infinite' }]);
    const [cardTypeInitialValue, setCardTypeInitialValue] = useState('1');

    const [rewardPrograms, setRewardPrograms] = useState([
        { value: null, label: ' ' },
        { value: 'Scotiapuntos', label: 'Scotiapuntos' },
        { value: 'Club Card', label: 'Club Card' },
        { value: 'Gaviotas', label: 'Gaviotas' },
        { value: 'Sonrisas', label: 'Sonrisas' }
    ]);
    const [rewardProgramsBkp, setRewardProgramsBkp] = useState([
        { value: null, label: ' ' },
        { value: 'Scotiapuntos', label: 'Scotiapuntos' },
        { value: 'Club Card', label: 'Club Card' },
        { value: 'Gaviotas', label: 'Gaviotas' },
        { value: 'Sonrisas', label: 'Sonrisas' }
    ]);

    const [cutoffDates, setCutoffDates] = useState([
        { value: '1', label: '1' },
        { value: '4', label: '4' },
        { value: '7', label: '7' },
        { value: '10', label: '10' },
        { value: '13', label: '13' },
        { value: '16', label: '16' },
        { value: '19', label: '19' },
        { value: '22', label: '22' },
        { value: '25', label: '25' }
    ]);
    const [cutoffDateInitialValue, setCutoffDateInitialValue] = useState('1');

    const onRadioAccountType = e => {
        setAccountType(e.target.value);
    }

    const onRadioAdditionalCreditApplicationChange = async e => {
        await setAdditionalCrediApplication(e.target.value)
    }

    const onRadioAdditionalCreditApplicationCChange = async e => {
        await setAdditionalCrediApplicationC(e.target.value)
    }

    const prevSubmit = async () => {
        setPressed(true)
    }

    const submit = async (e) => {
        e.preventDefault();
        try {
            const values = await form.validateFields()

            let FormData = {};

            Object.assign(FormData, location.state, values);

            FormData.paisDeResidencia = FormData.paisNacimiento;
            FormData.ciudad = FormData.localidad;

            FormData.sucursal = form.getFieldValue('sucursal');
            FormData.monedaPrestamo = form.getFieldValue('monedaPrestamo');
            FormData.deptoEDC = form.getFieldValue('deptoEDC');

            FormData.paqueteCA = form.getFieldValue('paqueteCA');

            if (!FormData.paqueteCA.includes('P')) {
                delete FormData.programa;
                delete FormData.programaDeTarjeta;
            }

            FormData.fechaNacimiento = dayjs(FormData.fechaNacimiento.$d.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS'); //FormData.fechaNacimiento.$d.toString();
            FormData.fechaIngreso = dayjs(FormData.fechaIngreso.$d.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS'); //FormData.fechaIngreso.$d.toString();

            if (FormData.fechaNacimientoConyuge !== undefined) {
                FormData.fechaNacimientoConyuge = dayjs(FormData.fechaNacimientoConyuge.$d.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS'); //FormData.fechaNacimientoConyuge.$d.toString();
            }
            const captchaValue = recaptcha.current.getValue();
            FormData.gRecaptchaResponse = captchaValue;

            if (accountType == "C") {
                FormData.programa = '22';
            }

            if (!FormData.tarjetaC.includes('4')) {
                switch (FormData.programa) {

                    case '01':
                        FormData.programaDeTarjeta = 'Scotia Puntos';
                        break;
                    case '03':
                        FormData.programaDeTarjeta = 'Club Card';
                        break;
                    case '07':
                        FormData.programaDeTarjeta = 'Gaviotas';
                        break;

                }
            }

            if (!captchaValue) {
                alert("Favor, verificar el reCAPTCHA!");
            }
            else {
                FormData.captchaValue = captchaValue;

                FormData = JSON.stringify(FormData);
                HttpService.post(basePath + '/api/send', FormData, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((response) => {
                        history.navigate('/alta1a1/solicitudexitosa');
                    })
                    .catch((error) => {
                        GenericErrors(error);
                    })
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo)
        }
    }

    const onAssignedCardChanged = e => {

        switch (e) {
            case '1':
                setCard(true);
                setCardTypes([{ value: '1', label: 'Platinum' },
                { value: '2', label: 'Internacional' },                
                { value: '4', label: 'Infinite' }
                ]);
                form.setFieldValue('tipoTarjetaC', '1');

                setRewardPrograms([
                    { value: null, label: ' ' },
                    { value: 'Scotia Puntos', label: 'Scotia Puntos' },
                    { value: 'Club Card', label: 'Club Card' },
                    { value: 'Gaviotas', label: 'Gaviotas' },
                    { value: 'Sonrisas', label: 'Sonrisas' }
                ]);
                setRewardProgramsBkp([
                    { value: null, label: ' ' },
                    { value: 'Scotia Puntos', label: 'Scotia Puntos' },
                    { value: 'Club Card', label: 'Club Card' },
                    { value: 'Gaviotas', label: 'Gaviotas' },
                    { value: 'Sonrisas', label: 'Sonrisas' }
                ]);
                form.setFieldValue('programaDeTarjeta', null);
                setTipoTarjeta('V');

                setCutoffDates([
                    { value: '1', label: '1' },
                    { value: '4', label: '4' },
                    { value: '7', label: '7' },
                    { value: '10', label: '10' },
                    { value: '13', label: '13' },
                    { value: '16', label: '16' },
                    { value: '19', label: '19' },
                    { value: '22', label: '22' },
                    { value: '25', label: '25' }
                ]);
                form.setFieldValue('cierreTarjetaC', '1');
                break;
            case '2':
                setCard(true);
                setCardTypes([{ value: '1', label: 'Platinum' },
                { value: '2', label: 'Internacional' },
                { value: '3', label: 'GOLD' },
                { value: '4', label: 'Infinite' }
                ]);
                form.setFieldValue('tipoTarjetaC', '1');

                setRewardPrograms([
                    { value: null, label: ' ' },
                    { value: 'Connect Miles', label: 'Connect Miles' },
                    { value: 'Membership Rewards', label: 'Membership Rewards' }
                ]);
                setRewardProgramsBkp([
                    { value: null, label: ' ' },
                    { value: 'Club Card', label: 'Club Card' },
                    { value: 'Connect Miles', label: 'Connect Miles' },
                    { value: 'Membership Rewards', label: 'Membership Rewards' }
                ]);
                form.setFieldValue('programaDeTarjeta', null);
                setTipoTarjeta('A');

                setCutoffDates([
                    { value: '7', label: '7' },
                    { value: '14', label: '14' },
                    { value: '21', label: '21' },
                    { value: '28', label: '28' }
                ]);
                form.setFieldValue('cierreTarjetaC', '7');
                break;
            default:
                setCard(false);
                break;
        }

    }

    const onAssignedCardTypeChanged = e => {

        let rewardProgramsCopy = [...rewardProgramsBkp];
        setRewardPrograms([...rewardProgramsCopy]);
        form.setFieldValue('programaDeTarjeta', 'Club Card');

        //tarjetaC = 1 => visa
        //tarjetaC = 2 => amex
        switch (e) {
            //Platinum
            case '1':
                if (form.getFieldValue('tarjetaC') === '2') {
                    setRewardPrograms(removeCrdItem(rewardProgramsCopy, 'Club Card'));
                    form.setFieldValue('programaDeTarjeta', 'Connect Miles');
                }
                break;
            //Gold
            case '3':
                if (form.getFieldValue('tarjetaC') === '2') {
                    setRewardPrograms(removeCrdItem(rewardProgramsCopy, 'Club Card'));
                    form.setFieldValue('programaDeTarjeta', 'Connect Miles');
                }
                break;
            //Infinite
            case '4':
                if (form.getFieldValue('tarjetaC') === '1') {
                    rewardProgramsCopy = [...removeCrdItem(rewardProgramsCopy, 'Gaviotas')];
                    rewardProgramsCopy = [...removeCrdItem(rewardProgramsCopy, 'Sonrisas')];
                    setRewardPrograms([...rewardProgramsCopy]);
                }
                else if (form.getFieldValue('tarjetaC') === '2') {
                    rewardProgramsCopy = [...removeCrdItem(rewardProgramsCopy, 'Club Card')];
                    rewardProgramsCopy = [...removeCrdItem(rewardProgramsCopy, 'Membership Rewards')];
                    form.setFieldValue('programaDeTarjeta', 'Connect Miles');
                    setRewardPrograms([...rewardProgramsCopy]);
                }
                break;
        }

    }

    const removeCrdItem = (array, cardName) => {
        const index = array.findIndex((element) => element.value === cardName);
        if (index >= 0) {
            array.splice(index, 1);
        }
        return array;
    }

    const onAdressChange = e => {
        if (e === '2') {
            setReceptionAdress(true);
            return;
        }
        setReceptionAdress(false);
    }

    const onZipCodeChange = async (value) => {
        setZipCode(value.target.value)
    }

    const onDepartmentChange = e => {
        if (e != 1) {
            setLocalityStatus(false);
        }
        else {
            setLocalityStatus(true);
        }
    }

    const zipCodeValidation = (rule, value, callback) => {

        if (localityStatus) {
            const minValue = 11000;
            const maxValue = 13000;

            if (zipCode >= minValue && zipCode <= maxValue) {
                return callback()
            } else {
                return callback("Por favor, escribe un valor entre 11000 y 13000.");
            }
        }
        else {
            return callback();
        }
    }

    const getCCRequestStatusElements = () => {
        const children = [];
        children.push(
            <Col xs={30} sm={50} md={20} lg={12} key={0}>
                <Form.Item
                    name={'tarjetaC'}
                    label={'Tarjeta seleccionada'}
                    initialValue="1"
                >
                    <Select onChange={onAssignedCardChanged}>
                        <Option value="1">Visa</Option>
                        <Option value="2">American Express</Option>
                        <Option value="3">Ninguna</Option>
                    </Select>
                </Form.Item>

                {isCardSelected ?

                    <Form.Item
                        name={'programaDeTarjeta'}
                        label={'Programa de premios'}
                        initialValue={null}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            }
                        ]}
                    >
                        <Select
                            options={rewardPrograms}
                        />
                    </Form.Item>

                    :

                    null

                }                

            </Col>
        );

        children.push(
            <Col xs={30} sm={50} md={20} lg={12} key={1}>

                {isCardSelected ?
                    <Form.Item
                        name={'tipoTarjetaC'}
                        label={'Tipo de tarjeta'}
                        initialValue={cardTypeInitialValue}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            }
                        ]}
                    >
                        <Select
                            options={cardTypes}
                            onChange={onAssignedCardTypeChanged}
                        />
                    </Form.Item>
                    :
                    null
                }

                {isCardSelected ?

                    <Form.Item
                        name={'cierreTarjetaC'}
                        label={'Día de cierre'}
                        initialValue={cutoffDateInitialValue}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            }
                        ]}
                    >
                        <Select
                            options={cutoffDates}
                        />
                    </Form.Item>


                    :

                    null

                }


            </Col>
        );

        return children;

    }

    const getReceptionAddress = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={50} md={20} lg={12} key={2}>
                <Form.Item
                    name={'estadoDeCuenta'}
                    label={'Recibir estado de cuenta'}
                    initialValue="1"
                >
                    <Select onChange={onAdressChange}>
                        <Option value="1">Si, a la misma dirección</Option>
                        <Option value="2">Si, a una nueva dirección</Option>
                    </Select>
                </Form.Item>
            </Col>

        );

        children.push(
            <Col xs={30} sm={50} md={20} lg={12} key={3}>
                {isNewReceptionAdress ?
                    <Form.Item
                        label={'País'}
                    >
                        <Input value={'URUGUAY'} disabled />
                    </Form.Item>

                    :

                    null

                }

                {isNewReceptionAdress ?
                    <Form.Item
                        name={'deptoEDC'}
                        label={'Departamento'}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio',
                            },
                        ]}
                        initialValue={'1'}
                    >
                        <Select
                            options={states}
                            onChange={onDepartmentChange}
                        />
                    </Form.Item>
                    :

                    null

                }


                {isNewReceptionAdress ?
                    <Form.Item
                        name={'localidadEDC'}
                        label={'Localidad'}
                    >
                        <Input disabled={localityStatus} maxLength={35} />
                    </Form.Item>

                    :

                    null

                }

                {isNewReceptionAdress ?
                    <Form.Item
                        name={'direccionEDC'}
                        label={'Dirección'}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            }
                        ]}
                    >
                        <Input placeholder='DIRECCIÓN' maxLength={35} />
                    </Form.Item>
                    :

                    null

                }

                {isNewReceptionAdress ?
                    <Form.Item
                        name={'direccionEDCNro'}
                        label={' '}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            },
                            {
                                pattern: new RegExp(NumberRegex()),
                                message: "Ingrese sólo números"
                            }
                        ]}
                    >
                        <Input className='numero' placeholder='NÚMERO' maxLength={35} />
                    </Form.Item>
                    :

                    null

                }

                {isNewReceptionAdress ?
                    <Form.Item
                        name={'direccionEDCApto'}
                    >
                        <Input className='numero' placeholder='APTO.' maxLength={35} />
                    </Form.Item>
                    :

                    null

                }

                {isNewReceptionAdress ?
                    <Form.Item
                        name={'codigoPostalEDC'}
                        label={'Código postal'}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            },
                            {
                                validator: zipCodeValidation
                            }
                        ]}
                    >
                        <Input
                            placeholder='CÓDIGO POSTAL'
                            onChange={onZipCodeChange}
                            maxLength={35}
                        />
                    </Form.Item>
                    :

                    null

                }
            </Col>,
        );

        return children
    }

    const getCreditApplication = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={50} md={20} lg={12} key={4}>
                <Form.Item
                    name={'deseaObtenerPrestamo'}
                    label={'¿Desea obtener su préstamo personal?'}                    
                    initialValue={additionalCreditApplication}
                >
                    <Radio.Group onChange={onRadioAdditionalCreditApplicationChange}>
                        <Radio value={'Si'}>Si</Radio>
                        <Radio value={'No'}>No</Radio>
                    </Radio.Group>
                </Form.Item>

                {additionalCreditApplication === 'Si' ?

                    <Form.Item
                        name={'plazoPrestamo'}
                        label={'Recibir estado de cuenta'}
                        initialValue="4"
                    >
                        <Select >
                            <Option value="2">15-17 Meses</Option>
                            <Option value="3">18-35 Meses</Option>
                            <Option value="4">36 Meses</Option>
                            <Option value="5">37-47 Meses</Option>
                            <Option value="6">48 Meses</Option>
                        </Select>
                    </Form.Item>

                    :
                    null
                }

                {additionalCreditApplication === 'Si' ?
                    <Form.Item
                        name={'montoPrestamo'}
                        label={'Monto del préstamo'}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            },
                            {
                                pattern: new RegExp(NumberRegex()),
                                message: "Ingrese sólo números"
                            }
                        ]}
                    >
                        <Input className='numero' placeholder='NÚMERO' maxLength={35} />
                    </Form.Item>
                    :

                    null

                }

                {additionalCreditApplication === 'Si' ?

                    <Form.Item
                        name={'monedaPrestamo'}
                        label={'Moneda'}
                        initialValue="1"
                    >
                        <Select options={marketRates} />
                    </Form.Item>

                    :
                    null
                }

            </Col>
        );
        return children;
    }

    const getAdditionalCreditApplicationRow1 = () => {
        const children = [];

        children.push(

            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                {/* <span class="textos">(Sin puntos ni guiones. Incluya el dígito verificador)</span> */}
                <Form.Item
                    name={'nombreRef1'}
                    label={'Nombre de referencia 1'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Nombre de referencia 1" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                {/* <span class="textos">(Sin puntos ni guiones. Incluya el dígito verificador)</span> */}
                <Form.Item
                    name={'direccionRef1'}
                    label={'Dirección de referencia 1'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Dirección de referencia 1" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                {/* <span class="textos">(Sin puntos ni guiones. Incluya el dígito verificador)</span> */}
                <Form.Item
                    name={'telefonoRef1'}
                    label={'Teléfono de referencia 1'}
                    normalize={valuesToUpperCase}
                >
                    <InputNumber type="number" style={{ width: '100%' }} placeholder="Teléfono de referencia 1" maxLength={35} />
                </Form.Item>

            </Col>,
        );

        return children;
    }

    const getAdditionalCreditApplicationRow2 = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'nombreRef2'}
                    label={'Nombre de referencia 2'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Nombre de referencia 2" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'direccionRef2'}
                    label={'Dirección de referencia 2'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Dirección de referencia 2" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'telefonoRef2'}
                    label={'Teléfono de referencia 2'}
                    normalize={valuesToUpperCase}
                >
                    <InputNumber type="number" style={{ width: '100%' }} placeholder="Teléfono de referencia 2" maxLength={35} />
                </Form.Item>

            </Col>,
        );

        return children;
    }
    const getAdditionalCreditApplicationRow3 = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'nombreRef3'}
                    label={'Nombre de referencia 3'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Nombre de referencia 3" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'direccionRef3'}
                    label={'Dirección de referencia 3'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="Dirección de referencia 3" maxLength={35} />
                </Form.Item>

            </Col>,
            <Col xs={30} sm={150} md={20} lg={8} key={0}>
                <Form.Item
                    name={'telefonoRef3'}
                    label={'Teléfono de referencia 3'}
                    normalize={valuesToUpperCase}
                >
                    <InputNumber type="number" style={{ width: '100%' }} placeholder="Teléfono de referencia 3" maxLength={35} />
                </Form.Item>

            </Col>,
        );

        return children;
    }

    function reCAPTCHAonExpired() {
        recaptcha.current.reset();
        console.log("reCAPTCHAonExpired:");
    }

    const valuesToUpperCase = (value) => (value ? value.toUpperCase() : '');

    return (
        <>

            <Spin tip="Loading..." spinning={loading} >
                <Form colon={false} className='form' form={form}>

                    <Title className='titleForm' level={5}>Solicitud de productos y servicios</Title>

                    <Row>
                        <Col span={8}>
                            <Form.Item
                                name={'cajaAhorroPesos'}
                                valuePropName='checked'
                                initialValue={true}
                            >
                                <Checkbox checked={true} >Caja Ahorro $</Checkbox>
                            </Form.Item>

                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name={'cajaAhorroDolares'}
                                valuePropName='checked'
                                initialValue={false}
                            >
                                <Checkbox>Caja Ahorro U$S</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Text>Cuenta y tarjeta de débito asociada:</Text>

                    <Form.Item
                        name={'paqueteCA'}
                        rules={[
                            {
                                required: true,
                                message: 'Opción requerida',
                            },
                        ]}
                    >
                        <Radio.Group onChange={onRadioAccountType}>
                            <Radio value={'C'}>Cuenta Básica <Image width={63} height={100} src={basePath + '/images/clasica.png'} /></Radio>
                            <Radio value={'P'}>Sueldo Ideal <Image width={63} height={100} src={basePath + '/images/premium.png'} /></Radio>
                        </Radio.Group>
                    </Form.Item>

                    {accountType === 'P' ?

                        <Text>Con esta tarjeta accedés a beneficios y descuentos. Consultá más información <Button onClick={() => {
                            window.open(
                                process.env.REACT_APP_SUELDO_IDEAL_URL, '_blank'
                            );
                        }} style={{padding:0}} type="link">acá</Button>.</Text>

                        :

                        null

                    }

                    {accountType === 'P' ?

                        <Title className='titleForm' level={5}>Programa puntos tarjeta de débito</Title>

                        :

                        null

                    }

                    {accountType === 'P' ?

                        <Form.Item
                            name={'programa'}
                            initialValue={'01'}
                        >
                            <Radio.Group>
                                <Radio value={'01'}>Clásica <Image width={63} height={100} src={basePath + '/images/premium.png'} /></Radio>
                                <Radio value={'03'}>Club Card <Image width={63} height={100} src={basePath + '/images/club.png'} /></Radio>
                                <Radio value={'07'}>Gaviotas <Image width={63} height={100} src={basePath + '/images/gaviota.png'} /></Radio>
                            </Radio.Group>
                        </Form.Item>

                        :
                        null

                    }

                    <Title className='titleForm' level={5}>Solicitud de cuenta corriente</Title>
                    <Row gutter={24}>
                        <Col xs={30} sm={50} md={20} lg={12} key={4}>
                            <Form.Item
                                name={'deseaObtenerCuentaCorriente'}
                                label={'¿Desea obtener su cuenta corriente?'}
                                initialValue={additionalCreditApplicationC}
                            >
                                <Radio.Group onChange={onRadioAdditionalCreditApplicationCChange}>
                                    <Radio value={'Si'}>Si</Radio>
                                    <Radio value={'No'}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>

                    {additionalCreditApplicationC === 'Si' ?

                        <Row gutter={12}>{getAdditionalCreditApplicationRow1()}</Row>
                        :
                        null
                    }
                    {additionalCreditApplicationC === 'Si' ?

                        <Row gutter={12}>{getAdditionalCreditApplicationRow2()}</Row>
                        :
                        null
                    }
                    {additionalCreditApplicationC === 'Si' ?

                        <Row gutter={12}>{getAdditionalCreditApplicationRow3()}</Row>
                        :
                        null
                    }

                    <Title className='titleForm' level={5}>Solicitud de tarjeta de crédito</Title>
                    <Row gutter={24}>{getCCRequestStatusElements()}</Row>


                    {isCardSelected ?

                        <Title className='titleForm' level={5}>Solicitud de estado de cuenta de la tarjeta de crédito</Title>

                        :

                        null

                    }

                    {isCardSelected ?

                        <Row style={{ hidden: isCardSelected }} gutter={24}>{getReceptionAddress()}</Row>

                        :

                        null

                    }

                    <Title className='titleForm' level={5}>Sucursal de retiro de tarjeta/s y firma de documentación</Title>

                    <Form.Item
                        name={'sucursal'}
                        label={'Sucursal retiro'}
                        rules={[
                            {
                                required: true,
                                message: 'Este campo es obligatorio.',
                            }
                        ]}
                    >
                        <Select options={dependencies} />
                    </Form.Item>

                    <Title className='titleForm' level={5}>Solicitud de Préstamo</Title>
                    <Row gutter={24}>{getCreditApplication()}</Row>

                    <Title className='titleForm' level={5}>Código de Seguridad</Title>
                    <Form.Item>
                        <ReCAPTCHA ref={recaptcha} sitekey={captchaApiKey} onExpired={reCAPTCHAonExpired} />
                    </Form.Item>



                    <Form.Item>
                        <Flex gap='small' wrap='wrap' vertical={false}>
                            <Button disabled={loading} danger type="primary" onClick={prevSubmit}>
                                Anterior
                            </Button>

                            <Button disabled={loading} danger type="primary" onClick={submit}>
                                Enviar
                            </Button>
                        </Flex>
                    </Form.Item>


                </Form>
                {isPrevButtonPressed && <Navigate to="/alta1a1/homepage" state={location.state} replace={true} />}
            </Spin>

        </>
    );
}

export { Step2 }